module.exports = __webpack_public_path__ + "img/w9-b4.23bd8c0d.jpg";